module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Man, God, Religion, "), _c('br'), _vm._v("and State")]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#geographical-classifications"
    }
  }, [_vm._v("Geographical Classifications")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#evolutionary-theories"
    }
  }, [_vm._v("Evolutionary Theories")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#man"
    }
  }, [_vm._v("Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#race-and-civilization"
    }
  }, [_vm._v("Race and Civilization")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#myths-and-the-birth-of-god"
    }
  }, [_vm._v("Myths and the Birth of God")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-rise-of-religion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rise of Religion")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#religion-and-race",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion and Race")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#christianity-and-african-enslavement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christianity and African Enslavement")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-hebrewsisraelites",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hebrews/Israelites")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#culture",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culture")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#jesus-and-christianity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus and Christianity")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-growth-of-christianity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Growth of Christianity")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#church-and-state",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church and State")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#the-first-schism-in-christianity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Schism in Christianity")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-rise-of-roman-catholicism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rise of Roman Catholicism")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#the-church-of-the-east",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church of the East")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-conversion-of-western-eurasia-europe-to-catholicism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Conversion of Western Eurasia (Europe) to Catholicism")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#the-rise-of-islam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rise of Islam")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#islam-and-the-african-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Islam and the African World")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#islam-and-the-mediterranean-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Islam and the Mediterranean World")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#theories-of-the-state",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theories of the State")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#global-capitalism-and-the-state",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Global Capitalism and the State")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#global-labor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Global Labor")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#developmental-challenges",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Developmental Challenges")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#globalized-time-and-space",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Globalized Time and Space")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#the-war-on-drugs-and-the-crisis-of-capitalism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War on Drugs and the Crisis of Capitalism")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0